import styled from "styled-components";

export const BodyStyles = styled.div`

thead {
    color: var(--shape)
}

.accordion-button:not(.collapsed) {
  color: inherit;
  background-color: inherit;
  box-shadow: inset 0 calc(var(inherit) * -1) 0 var(inherit);
}

.tableCenter{
    text-align: left;
    margin-left: auto;
    margin-right: auto;
}

.loading {
    margin-top: 16.5rem;
}

.loading-overlay {
    position: absolute !important;
    display: absolute;
    font-weight: 600;
    background: rgba(255,255,255,0.4);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: black;
}

.alert-heading {
    svg {
        font-size: 1.8rem;
    }
}

.alert-primary {
    svg {
        font-size: 1.3rem;
    }
}

.alert-warning {
    svg {
        font-size: 1.3rem;
    }
}

table {
    table-layout: fixed;
    margin-bottom: 0;
}

span {
    color: var(--red);
}

td {
    word-wrap: break-word;

    svg {
        font-size: 1.4rem;
        cursor: pointer;

        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: center;

        &:hover {
            color: var(--red);
            cursor: pointer;
        } 
    }

}
`